import { AR_PLATFORM, AR_SUPPORT, XR_MODES } from "../constants";
import EighthWall from "./EighthWall";
// import WebXR from "./WebXR";
import Event from "./Event";

const mod = () => {
  const platforms = {
    // [AR_PLATFORM.WEBXR]: WebXR,
    [AR_PLATFORM.EIGHTHWALL]: EighthWall,
  };
  let support = AR_SUPPORT.INITIALIZING;
  let platform = AR_PLATFORM.INITIALIZING;

  const getPlatformsInInit = () =>
    Object.values(platforms).filter(
      (ele) => ele.isSupported().support === AR_SUPPORT.INITIALIZING
    );

  const supportCallback = () => {
    if (getPlatformsInInit().length === 0) {
      console.log(
        "Checking result",
        // WebXR.isSupported(),
        EighthWall.isSupported()
      );
      // const arCheckOrder = [WebXR, EighthWall];
      const arCheckOrder = [EighthWall];
      const arOption = arCheckOrder.find(
        (opt) => opt.isSupported().support === AR_SUPPORT.SUPPORTED
      );
      if (arOption) {
        support = AR_SUPPORT.SUPPORTED;
        platform = arOption.isSupported().platform;
      } else {
        support = AR_SUPPORT.NOT_SUPPORTED;
        platform = AR_PLATFORM.NONE;
      }
      Event.sendSMEvent(support);
      Event.sendSMEvent(platform);
    }
  };

  const removeCanvasFromDom = () => {
    if (document.getElementById("SCENEAR")) {
      if (platform === "AR_PLATFORM_8thwall") {
        document.body.removeChild(document.getElementById("SCENEAR"));
      } else {
        document
          .getElementsByClassName("renderer")[0]
          .removeChild(document.getElementById("SCENEAR"));
      }
    }
  };

  const getXRModeFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    // console.log(`PARAMS${params.get("ar")}`);
    if (params.get("ar") === "1") {
      return XR_MODES.AR;
    }
    return XR_MODES.XR;
  };

  const updateSearchParams = (xrMode) => {
    console.log("Updating the search params", xrMode);
    const url = new URL(window.location);
    const searchXRMode = getXRModeFromURL();
    if (searchXRMode !== xrMode) {
      url.searchParams.set("ar", xrMode === XR_MODES.AR ? 1 : 0);
      window.history.pushState({}, "", url);
      // console.log("vibhor window reload", url);
      // window.location.href = url.href;
    }
  };

  return {
    isSupported: () => ({ support, platform }),
    startCheckSupport: () => {
      Object.values(platforms).forEach((ele) =>
        ele.checkSupport(supportCallback)
      );
    },
    getSupport: () => support,
    getPlatform: () => platform,
    getPlatformModule: () => {
      console.log("StateMachine platform is ", platforms, platform);
      return platforms[platform];
    },
    checkURLForAR: () => {
      const xrMode = getXRModeFromURL();
      console.log("Checking URL for AR", xrMode);
      return xrMode;
    },
    updateSearchParams: (xrMode) => updateSearchParams(xrMode),
    add: (object) => {
      platforms[platform].getSceneDetails().scene.add(object);
    },
    remove: (object) => {
      platforms[platform].getSceneDetails().scene.remove(object);
    },
    removeCanvas: () => {
      removeCanvasFromDom();
    },
    startAR: (hdriTexture) => platforms[platform].startAR(hdriTexture),
    getSceneDetails: () => platforms[platform].getSceneDetails(),
    stopAR: () => platforms[platform].stopAR(),
    startHitTest: (callback) => platforms[platform].startHitTest(callback),
    stopHitTest: () => platforms[platform].stopHitTest(),
    getScale: () => platforms[platform].getScale(),
  };
};

const ARPlatform = mod();
export default ARPlatform;
